export const BOT_CONFIG_POPULATE_FULL = [
    "accountMovements",
    "strategy",
    "subscription",
    "stats",
    "strategy.exchanges",
    "exchange_account.exchange",
    "exchange_account.user",
    "strategy.logo",
    "subscription.pm_paymentMethod",
    "statistics.history",
    "statistics.periodicalStats",
];
export const BOT_CONFIG_POPULATE_LIST = [
    "strategy",
    "strategy.logo",
    "strategy.exchanges",
    "stats",
    "exchange_account.exchange",
    "subscription",
    "statistics.history",
];
export const BOT_CONFIG_POPULATE_MOBILE = [
    "accountMovements",
    "strategy",
    "subscription",
    "stats",
    "strategy.exchanges",
    "exchange_account.exchange",
    "exchange_account.user",
    "strategy.logo",
    "subscription.pm_paymentMethod",
    "statistics.history",
    "statistics.periodicalStats",
];
export const BOT_CONFIG_POPULATE_MINIMAL = [
    "strategy",
    "exchange_account",
    "stats",
];
export const BOT_CONFIG_POPULATE_BACKOFFICE = [
    "accountMovements",
    "strategy",
    "subscription",
    "stats",
    "strategy.exchanges",
    "exchange_account.exchange",
    "strategy.logo",
    "subscription.pm_paymentMethod",
    "statistics.history",
];
// Combined export for convenience
export const BOT_CONFIG_POPULATE = {
    FULL: BOT_CONFIG_POPULATE_FULL,
    LIST: BOT_CONFIG_POPULATE_LIST,
    MOBILE: BOT_CONFIG_POPULATE_MOBILE,
    MINIMAL: BOT_CONFIG_POPULATE_MINIMAL,
    BACKOFFICE: BOT_CONFIG_POPULATE_BACKOFFICE,
};
